
// INIT Shorcuts
// On init un shortcut pour redirect vers l'admin, cmd shift l
Mousetrap.bind(['ctrl+l', 'meta+l'], (e) => {
    e.preventDefault();
    e.stopPropagation();
    // Define new event
    window.location.href = '/admin/login';
});